{{ num }}<span class="trailing-zeros" *ngIf="hasZeros">{{ zeros }}</span>
